<template>
  <component
    :is="headerTag"
    v-if="text"
    class="font-bold text-[#2B2926] tracking-[-0.03em]"
    :class="headerClasses"
    :data-blok-c="dataBlokC"
    :data-blok-uid="dataBlokUid"
  >
    <span v-html="formattedText"></span>
  </component>
</template>

<script>
export default {
  name: 'ContentHeader',
  props: {
    text: {
      type: String,
      default: '',
    },
    isHtml: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      default: 2,
      validator: value => value >= 1 && value <= 6,
    },
    dataBlokC: {
      type: String,
      default: '',
    },
    dataBlokUid: {
      type: String,
      default: '',
    },
  },
  computed: {
    formattedText() {
      if (!this.text) return '';
      return this.isHtml ? this.text : this.escapeHtml(this.text);
    },
    headerTag() {
      return `h${this.level}`;
    },
    headerClasses() {
      const levelMap = {
        1: 'text-[2rem] leading-[2.5rem] md:text-[2.5rem] md:leading-[3rem]',
        2: 'text-[1.75rem] leading-[2.25rem] md:text-[2rem] md:leading-[2.5rem]',
        3: 'text-[1.5rem] leading-[2rem] md:text-[1.75rem] md:leading-[2.25rem]',
        4: 'text-[1.25rem] leading-[1.75rem] md:text-[1.5rem] md:leading-[2rem]',
        5: 'text-[1.125rem] leading-[1.5rem] md:text-[1.25rem] md:leading-[1.75rem]',
        6: 'text-[1rem] leading-[1.5rem] md:text-[1.125rem] md:leading-[1.5rem]',
      };
      return levelMap[this.level] || levelMap[2];
    },
  },
  methods: {
    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    },
  },
};
</script>

<style scoped>
* {
  font-family: 'Inter', 'aktiv-grotesk', sans-serif;
}

:deep(b),
:deep(strong) {
  font-weight: 700;
}

:deep(i),
:deep(em) {
  font-style: italic;
}

:deep(u) {
  text-decoration: underline;
}
</style>
